import { render } from "./FlowRenderer.vue?vue&type=template&id=8bec4512"
import script from "./FlowRenderer.vue?vue&type=script&lang=js"
export * from "./FlowRenderer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__